import { useTranslation } from "react-i18next";
import { Pressable } from "react-native";
import { Caption, Text } from "react-native-paper";

import { useAppTheme } from "@memorang/ui/useAppTheme";

import type { OriginalStimulusTypes } from "@memorang/types";
import Box from "@memorang/ui/components/Box";
import Button from "@memorang/ui/components/Button";
import AudioPlayerContainer from "../containers/AudioPlayerContainer";
import { useCtaInfo } from "./useCtaInfo";

export const PassageStem = ({
	parentStem,
	parentAudio,
	toggleShowReadMore,
	index,
	numPassageItems,
	parentTitle,
	parentType,
	itemId,
}: {
	parentStem?: string;
	numPassageItems?: number;
	inReviewMode?: boolean;
	toggleShowReadMore?: () => void;
	index?: number;
	parentAudio?: string;
	parentTitle?: string;
	parentType: OriginalStimulusTypes;
	itemId: number;
}) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const { text: cta, icon } = useCtaInfo(parentType);

	return (
		<Box>
			<Box
				backgroundColor={theme.colors.surface}
				borderBottomWidth={1}
				borderBottomColor={theme.palette.divider}
			>
				{parentAudio && (
					<AudioPlayerContainer uri={parentAudio} itemId={itemId} />
				)}
				{parentStem || parentTitle ? (
					<Pressable onPress={toggleShowReadMore}>
						<Box
							flexDirection="row"
							justifyContent="space-between"
							alignItems="center"
							paddingBottom={16}
						>
							<Box paddingHorizontal={16} flex={1}>
								<Text variant="titleMedium" numberOfLines={1}>
									{parentTitle}
								</Text>
								<Caption>
									{t("session.passageStem.itemOfTotal", {
										current: index,
										total: numPassageItems,
									})}
								</Caption>
							</Box>
							<Button icon={icon} mode="text" onPress={toggleShowReadMore}>
								{cta}
							</Button>
						</Box>
					</Pressable>
				) : null}
			</Box>
		</Box>
	);
};
